import type { IconName } from "@similarweb/icons";

import {
    CONNECTOR_GOOGLE_SHEETS_DESCRIPTION,
    CONNECTOR_GOOGLE_SHEETS_TITLE,
    CONNECTOR_HUBSPOT_DESCRIPTION,
    CONNECTOR_HUBSPOT_TITLE,
} from "app/pages/sales-intelligence/modules/manage-integrations/constants/translations";

export type ConnectorId = "hubspot" | "google-sheets";

export interface IConnectorConfig {
    id: ConnectorId;
    titleKey: string;
    descriptionKey: string;
    iconName: IconName;
    connectLink: string;
    guideLink: string;
    trackingName: string;
}

export const CONNECTORS: readonly IConnectorConfig[] = [
    {
        id: "hubspot",
        titleKey: CONNECTOR_HUBSPOT_TITLE,
        descriptionKey: CONNECTOR_HUBSPOT_DESCRIPTION,
        iconName: "hubspot-cloud",
        connectLink: "https://ecosystem.hubspot.com/marketplace/listing/similarweb-sales-intelligence",
        guideLink:
            "https://support.similarweb.com/hc/en-us/articles/33685202185245-Using-Similarweb-Sales-Intelligence-Insights-Card-in-HubSpot",
        trackingName: "HubSpot",
    },
    {
        id: "google-sheets",
        titleKey: CONNECTOR_GOOGLE_SHEETS_TITLE,
        descriptionKey: CONNECTOR_GOOGLE_SHEETS_DESCRIPTION,
        iconName: "google-sheets",
        connectLink:
            "https://workspace.google.com/marketplace/app/the_official_similarweb_for_google_sheet/131023728709?flow_type=2",
        guideLink:
            "https://support.similarweb.com/hc/en-us/articles/37028592655901-Using-Sales-Intelligence-for-Google-Sheets-Add-on#h_01KVMZEWR2ZVGGAZ24SNKEWZNX",
        trackingName: "Google Sheets",
    },
];
